export default "__VITE_ASSET__D$kARJ_G__"